export const downloadFile = (data, filename) => {
    const link = document.createElement('a');
    link.href = data;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};